<template>
  <div>
    <div class="order-card">
      <van-row class="order-title">合同基本信息</van-row>
      <el-table :data="masterTableData" border size="small" empty-text="无数据变化">
        <el-table-column prop="fieldName" label="字段" width="100" />
        <el-table-column prop="originalValue" label="原值" min-width="100">
          <template #default="{ row }">
            <span class="old-value">{{ row.originalValue }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="modifiedValue" label="新值" min-width="100">
          <template #default="{ row }">
            <span class="new-value">{{ row.modifiedValue }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="order-card">
      <van-row class="order-title">合同产品明细</van-row>
      <!-- 子表差异 -->
      <!--      <div class="diff-section" v-if="hasProductDifferences">-->
      <div v-if="hasProductDifferences">
        <!-- 新增的行 -->
        <div v-if="addedProducts.length > 0" class="operation-section">
          <h4 class="operation-title added">新增行 ({{ addedProducts.length }}行)</h4>
          <div v-for="detail in addedProducts" :key="detail.lineNo" class="detail-group">
            <div class="detail-header added">
              <span class="lineNo">行号: {{ detail.lineNo }}</span>
            </div>
            <el-table :data="detail.rows" border size="small" class="detail-table">
              <el-table-column prop="fieldName" label="字段" width="150" />
              <el-table-column prop="modifiedValue" label="新值" min-width="200">
                <template #default="{ row }">
                  <span class="new-value">{{ row.modifiedValue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 删除的行 -->
        <div v-if="deletedProducts.length > 0" class="operation-section">
          <h4 class="operation-title deleted">删除行 ({{ deletedProducts.length }}行)</h4>
          <div v-for="detail in deletedProducts" :key="detail.lineNo" class="detail-group">
            <div class="detail-header deleted">
              <span class="lineNo">行号: {{ detail.lineNo }}</span>
            </div>
            <el-table :data="detail.rows" border size="small" class="detail-table">
              <el-table-column prop="fieldName" label="字段" width="150" />
              <el-table-column prop="originalValue" label="原值" min-width="200">
                <template #default="{ row }">
                  <span class="old-value">{{ row.originalValue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 修改的行 -->
        <div v-if="modifiedProducts.length > 0" class="operation-section">
          <h4 class="operation-title modified">修改行 ({{ modifiedProducts.length }}行)</h4>
          <div v-for="detail in modifiedProducts" :key="detail.lineNo" class="detail-group">
            <div class="detail-header modified">
              <span class="lineNo">行号: {{ detail.lineNo }}</span>
            </div>
            <el-table :data="detail.rows" border size="small" class="detail-table">
              <el-table-column prop="fieldName" label="字段" width="100" />
              <el-table-column prop="originalValue" label="原值" min-width="100">
                <template #default="{ row }">
                  <span class="old-value">{{ row.originalValue }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="modifiedValue" label="新值" min-width="100">
                <template #default="{ row }">
                  <span class="new-value">{{ row.modifiedValue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 无差异提示 -->
      <div v-if="!hasProductDifferences" class="no-differences">
        <el-empty description="无数据变化" />
      </div>
    </div>
    <div class="order-card">
      <van-row class="order-title">合同付款阶段</van-row>
      <!-- 子表差异 -->
      <div v-if="hasPayStageDifferences">
        <!-- 新增的行 -->
        <div v-if="addedPayStages.length > 0" class="operation-section">
          <h4 class="operation-title added">新增行 ({{ addedPayStages.length }}行)</h4>
          <div v-for="detail in addedPayStages" :key="detail.sequenceCode" class="detail-group">
            <div class="detail-header added">
              <span class="sequenceCode">行号: {{ detail.sequenceCode }}</span>
            </div>
            <el-table :data="detail.rows" border size="small" class="detail-table">
              <el-table-column prop="fieldName" label="字段" width="150" />
              <el-table-column prop="modifiedValue" label="新值" min-width="200">
                <template #default="{ row }">
                  <span class="new-value">{{ row.modifiedValue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 删除的行 -->
        <div v-if="deletedPayStages.length > 0" class="operation-section">
          <h4 class="operation-title deleted">删除行 ({{ deletedPayStages.length }}行)</h4>
          <div v-for="detail in deletedPayStages" :key="detail.sequenceCode" class="detail-group">
            <div class="detail-header deleted">
              <span class="sequenceCode">行号: {{ detail.sequenceCode }}</span>
            </div>
            <el-table :data="detail.rows" border size="small" class="detail-table">
              <el-table-column prop="fieldName" label="字段" width="150" />
              <el-table-column prop="originalValue" label="原值" min-width="200">
                <template #default="{ row }">
                  <span class="old-value">{{ row.originalValue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 修改的行 -->
        <div v-if="modifiedPayStages.length > 0" class="operation-section">
          <h4 class="operation-title modified">修改行 ({{ modifiedPayStages.length }}行)</h4>
          <div v-for="detail in modifiedPayStages" :key="detail.sequenceCode" class="detail-group">
            <div class="detail-header modified">
              <span class="sequenceCode">行号: {{ detail.sequenceCode }}</span>
            </div>
            <el-table :data="detail.rows" border size="small" class="detail-table">
              <el-table-column prop="fieldName" label="字段" width="100" />
              <el-table-column prop="originalValue" label="原值" min-width="100">
                <template #default="{ row }">
                  <span class="old-value">{{ row.originalValue }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="modifiedValue" label="新值" min-width="100">
                <template #default="{ row }">
                  <span class="new-value">{{ row.modifiedValue }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 无差异提示 -->
      <div v-if="!hasPayStageDifferences" class="no-differences">
        <el-empty description="无数据变化" />
      </div>
    </div>
  </div>
</template>

<script>
import { getObjByUuid } from '@/api/PurchaseContractChange'
import { isEqual } from 'lodash'
// 字段映射配置 - 只比较配置中定义的字段
const FIELD_MAPPINGS = {
  // 主表字段映射（只比较这些字段）
  master: {
    sumAmount: '合同金额'
  },
  // 产品明细表字段映射（只比较这些字段）
  productItem: {
    lineNo: '行号',
    productQty: '产品数量',
    productPrice: '单价',
    productAmount: '产品外包金额',
    arrivalDate: '到货时间',
    taxRate: '税率',
    contractStatusDict: '合同状态'
  },
  // 付款阶段表字段映射（只比较这些字段）
  payStageItem: {
    sequenceCode: '行号',
    payPercent: '付款比例'
  }
}
export default {
  name: 'ModifyInfo',
  data() {
    return {
      originMaster: {},
      originProductList: [],
      originPayStageList: []
    }
  },
  props: {
    master: {
      type: Object
    },
    productList: {
      type: Array
    },
    payStageList: {
      type: Array
    }
  },
  computed: {
    contractStatusOptions() {
      return this.$store.getters.dicts.purchase_contract_status
    },
    // 获取主表需要比较的字段列表
    masterFields() {
      return Object.keys(FIELD_MAPPINGS.master)
    },
    // 获取产品明细表需要比较的字段列表
    productFields() {
      return Object.keys(FIELD_MAPPINGS.productItem)
    },
    // 获取付款阶段表需要比较的字段列表
    payStageFields() {
      return Object.keys(FIELD_MAPPINGS.payStageItem)
    },
    // 主表表格数据
    masterTableData() {
      const differences = this.compareMaster()
      return differences.filter(row => row.hasDiff)
    },
    // 产品明细表表格数据
    productTableData() {
      const differences = this.compareProducts()
      return differences.filter(detail => detail.operation !== 'unchanged' || detail.rows.some(row => row.hasDiff))
    },
    // 付款阶段表表格数据
    payStageTableData() {
      const differences = this.comparePayStages()
      return differences.filter(detail => detail.operation !== 'unchanged' || detail.rows.some(row => row.hasDiff))
    },
    // 是否有产品明细表差异
    hasProductDifferences() {
      return this.productTableData.length > 0
    },
    // 新增的产品明细行
    addedProducts() {
      const addedProducts = this.productTableData.filter(item => item.operation === 'added')
      // 字段转换
      this.productFieldConvert(addedProducts)
      return addedProducts
    },
    // 删除的产品明细行
    deletedProducts() {
      const deletedProducts = this.productTableData.filter(item => item.operation === 'deleted')
      // 字段转换
      this.productFieldConvert(deletedProducts)
      return deletedProducts
    },
    // 修改的产品明细行
    modifiedProducts() {
      const modifiedProducts = this.productTableData.filter(item => item.operation === 'modified')
      // 字段转换
      this.productFieldConvert(modifiedProducts)
      return modifiedProducts
    },
    // 是否有付款阶段表差异
    hasPayStageDifferences() {
      return this.payStageTableData.length > 0
    },
    // 新增的付款阶段行
    addedPayStages() {
      return this.payStageTableData.filter(item => item.operation === 'added')
    },
    // 删除的付款阶段行
    deletedPayStages() {
      return this.payStageTableData.filter(item => item.operation === 'deleted')
    },
    // 修改的付款阶段行
    modifiedPayStages() {
      return this.payStageTableData.filter(item => item.operation === 'modified')
    }
  },
  mounted() {
    // this.initData()
  },
  methods: {
    async initData(sourceContractUuid) {
      // 获取变更前数据
      const originRes = await getObjByUuid(sourceContractUuid)
      if (originRes && originRes.success) {
        if (originRes.data) {
          this.originMaster = originRes.data
        }
        if (originRes.data && originRes.data.cmPurchaseContractItemList) {
          this.originProductList = originRes.data.cmPurchaseContractItemList
        }
        if (originRes.data && originRes.data.cmPurchaseContractPayStageList) {
          this.originPayStageList = originRes.data.cmPurchaseContractPayStageList
        }
      }
    },
    /**
     * 产品明细表字段转换
     *
     * @param products
     */
    productFieldConvert(products) {
      // 转换合同状态
      products.forEach(detail => {
        detail.rows.forEach(row => {
          if (row.field === 'contractStatusDict') {
            if (row.originalValue) {
              const contractStatusOption = this.contractStatusOptions.find(item => item.value === row.originalValue)
              row.originalValue = contractStatusOption ? contractStatusOption.labelDefault : row.originalValue
            }
            if (row.modifiedValue) {
              const contractStatusOption = this.contractStatusOptions.find(item => item.value === row.modifiedValue)
              row.modifiedValue = contractStatusOption ? contractStatusOption.labelDefault : row.modifiedValue
            }
          }
        })
      })
    },
    /**
     * 比较主表数据 - 只返回有差异的字段
     *
     * @returns {{field: *, fieldName, originalValue: *, modifiedValue: *, hasDiff: *}[]|*[]}
     */
    compareMaster() {
      if (!this.originMaster && !this.master) return []

      return this.masterFields.map(field => {
        const originalValue = this.originMaster[field]
        const modifiedValue = this.master[field]
        const hasDiff = !isEqual(originalValue, modifiedValue)

        return {
          field,
          fieldName: FIELD_MAPPINGS.master[field] || field,
          originalValue,
          modifiedValue,
          hasDiff
        }
      })
    },
    /**
     * 比较产品明细表数据 - 只返回有差异的行
     *
     * @returns {*[]}
     */
    compareProducts() {
      const originalMap = new Map(this.originProductList.map(item => [item.lineNo, item]))
      const modifiedMap = new Map(this.productList.map(item => [item.lineNo, item]))
      const results = []
      // 处理新增和修改的行
      for (const [lineNo, modifiedItem] of modifiedMap) {
        const originalItem = originalMap.get(lineNo)
        let operation = 'unchanged'
        if (!originalItem) {
          operation = 'added'
        } else if (!this.isDetailRowEqual(originalItem, modifiedItem, this.productFields)) {
          operation = 'modified'
        }
        // 只处理有差异的行
        if (operation !== 'unchanged') {
          const rows = this.compareDetailRow(
            originalItem,
            modifiedItem,
            operation,
            this.productFields,
            FIELD_MAPPINGS.productItem
          )
          if (rows.length > 0) {
            results.push({
              lineNo,
              operation,
              rows
            })
          }
        }
      }
      // 处理删除的行
      for (const [lineNo, originalItem] of originalMap) {
        if (!modifiedMap.has(lineNo)) {
          const rows = this.compareDetailRow(
            originalItem,
            null,
            'deleted',
            this.productFields,
            FIELD_MAPPINGS.productItem
          )
          if (rows.length > 0) {
            results.push({
              lineNo,
              operation: 'deleted',
              rows
            })
          }
        }
      }
      // 按行号排序
      return results.sort((a, b) => a.lineNo - b.lineNo)
    },
    /**
     * 比较付款阶段表数据 - 只返回有差异的行
     *
     * @returns {*[]}
     */
    comparePayStages() {
      const originalMap = new Map(this.originPayStageList.map(item => [item.sequenceCode, item]))
      const modifiedMap = new Map(this.payStageList.map(item => [item.sequenceCode, item]))
      const results = []
      // 处理新增和修改的行
      for (const [sequenceCode, modifiedItem] of modifiedMap) {
        const originalItem = originalMap.get(sequenceCode)
        let operation = 'unchanged'
        if (!originalItem) {
          operation = 'added'
        } else if (!this.isDetailRowEqual(originalItem, modifiedItem, this.payStageFields)) {
          operation = 'modified'
        }
        // 只处理有差异的行
        if (operation !== 'unchanged') {
          const rows = this.compareDetailRow(
            originalItem,
            modifiedItem,
            operation,
            this.payStageFields,
            FIELD_MAPPINGS.payStageItem
          )
          if (rows.length > 0) {
            results.push({
              sequenceCode,
              operation,
              rows
            })
          }
        }
      }
      // 处理删除的行
      for (const [sequenceCode, originalItem] of originalMap) {
        if (!modifiedMap.has(sequenceCode)) {
          const rows = this.compareDetailRow(
            originalItem,
            null,
            'deleted',
            this.payStageFields,
            FIELD_MAPPINGS.payStageItem
          )
          if (rows.length > 0) {
            results.push({
              sequenceCode,
              operation: 'deleted',
              rows
            })
          }
        }
      }
      // 按行号排序
      return results.sort((a, b) => a.sequenceCode - b.sequenceCode)
    },
    /**
     * 比较行数据 - 只返回有差异的字段
     *
     * @param originalRow
     * @param modifiedRow
     * @param operation
     * @param fields
     * @returns {*}
     */
    compareDetailRow(originalRow, modifiedRow, operation, fields, fieldMappings) {
      return fields
        .map(field => {
          const originalValue = originalRow ? originalRow[field] : null
          const modifiedValue = modifiedRow ? modifiedRow[field] : null

          let hasDiff
          if (operation === 'added' || operation === 'deleted') {
            hasDiff = true
          } else {
            hasDiff = !isEqual(originalValue, modifiedValue)
          }
          // 只返回有差异的字段
          if (!hasDiff) return null
          return {
            field,
            fieldName: fieldMappings[field] || field,
            originalValue,
            modifiedValue,
            hasDiff
          }
        })
        .filter(item => item !== null)
    },
    /**
     * 判断行数据是否相等
     *
     * @param row1
     * @param row2
     * @param fields
     * @returns {boolean}
     */
    isDetailRowEqual(row1, row2, fields) {
      if (!row1 && !row2) return true
      if (!row1 || !row2) return false

      for (const field of fields) {
        if (!isEqual(row1[field], row2[field])) {
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="css" scoped>
.order-card {
  border: 1px solid #969799;
  border-radius: 10px;
  padding: 0 10px 10px 10px;
  margin-bottom: 10px;
}
.order-title {
  color: #000;
  font-weight: bold;
  margin: 10px 0;
  font-size: 16px;
}
.order-detail {
  color: #323233;
  line-height: 28px;
  font-size: 16px;
}

.diff-section {
  margin-bottom: 24px;
  background: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.diff-section h3 {
  margin-bottom: 16px;
  color: #303133;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.operation-section {
  margin-bottom: 24px;
}

.operation-title {
  font-size: 14px;
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.operation-title.added {
  background-color: #f0f9ff;
  color: #1890ff;
  border-left: 4px solid #1890ff;
}

.operation-title.deleted {
  background-color: #fef0f0;
  color: #f56c6c;
  border-left: 4px solid #f56c6c;
}

.operation-title.modified {
  background-color: #fdf6ec;
  color: #e6a23c;
  border-left: 4px solid #e6a23c;
}

.detail-group {
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.detail-header {
  padding: 12px 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-header.added {
  background-color: #f0f9ff;
  border-left: 4px solid #1890ff;
}

.detail-header.deleted {
  background-color: #fef0f0;
  border-left: 4px solid #f56c6c;
}

.detail-header.modified {
  background-color: #fdf6ec;
  border-left: 4px solid #e6a23c;
}

.lineNo {
  color: #606266;
  font-size: 14px;
}

.detail-table {
  margin: 0;
}

.old-value {
  color: #f56c6c;
  text-decoration: line-through;
  background-color: #fef0f0;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.new-value {
  color: #67c23a;
  background-color: #f0f9eb;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.no-differences {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .el-table {
  border-radius: 6px;
}

::v-deep .el-table .cell {
  word-break: break-word;
  padding: 8px 12px;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}
</style>
